export { default as Visualizar } from './Visualizar';
